export { TenantDetails } from "./TenantDetails";
